import { EmailLog } from '@/@types/EmailLog';
import { api } from '@/services/api';

interface EmailResponse {
  data: EmailLog;
}

export const EmailsService = {
  /**
   * Reenviar e-mail que falhou
   */
  resendEmail: async (orderUuid: string, emailId: string): Promise<EmailLog> => {
    const response = await api.post<EmailResponse>(
      `/v1/sells/${orderUuid}/emails/${emailId}/resend`
    );
    return response.data.data;
  },

  /**
   * Enviar e-mail de acesso manual para a área do cliente
   */
  sendCustomerAccess: async (orderUuid: string): Promise<EmailLog> => {
    const response = await api.post<EmailResponse>(
      `/v1/sells/${orderUuid}/send-access`
    );
    return response.data.data;
  },
};
